import { Router } from 'router5';
import { Route } from 'config/routes';
import { AdGetter, BannerIntersectionFn, IAd, ScreenType } from './types';
import { BannersByDocIdResponse, DealType } from 'utils/entities';
import { ImageOptions } from 'hooks/useImageUrlBuilder';

export function createExposeBannerIntersection(cb: (banner: IAd, index: number) => void): BannerIntersectionFn {
  const exposedIds = new Set();
  let eventIndex = 1;

  return (entry, banner, id) => {
    const notExpose = !exposedIds.has(id);

    if (entry.isIntersecting && notExpose && id) {
      exposedIds.add(id);
      cb(banner, eventIndex++);
    }
  };
}

export function getAds(
  banners: BannersByDocIdResponse[],
  router: Router,
  constructImageURI: (path: string, options?: ImageOptions) => string,
  screenType: ScreenType
) {
  return banners.reduce<IAd[]>((acc, item) => {
    const bannerPath =
      screenType === ScreenType.Mobile ? item.mobileImage : item.desktopImage;
    if (!bannerPath) return acc;

    const routeNameForBuildLink = item.isCommercial
      ? Route.ProjectPageCommercial
      : Route.ProjectPage;
    const link = item.isExternalLink
      ? item.link
      : router.buildPath(routeNameForBuildLink, { id: item.id });
    return [
      ...acc,
      {
        id: item.id,
        imageUrl: constructImageURI(bannerPath),
        imageAlt: item.link ? item.link : item.id,
        routeName: routeNameForBuildLink,
        routeParams: { id: item.id, dealType: DealType.Buy },
        link,
        isExternalLink: item.isExternalLink,
      },
    ];
  }, []);
}

export const getBanner: (
  ads: IAd[],
  source: string,
  onBannerIntersection: BannerIntersectionFn
) => AdGetter = (
  ads: IAd[],
  source: string,
  onBannerIntersection: BannerIntersectionFn
) => {
  let BANNER_INDEX = -1;
  return () => {
    const arrIndex = ++BANNER_INDEX % ads.length;
    const ad = ads[arrIndex];

    return ad
      ? {
        ...ad,
        dynamicId: source + ad.id + BANNER_INDEX,
        onBannerIntersection,
      }
      : undefined;
  };
};
